import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { A, preventDefault } from '#modules/browser';
import { Env } from '#modules/env';
import { MenuItemId, MenuItemURL } from './constants';
import { PageContext } from './contexts';

const orderedItemIds = [
  ...(MenuItemId._EXAMPLE ? [MenuItemId._EXAMPLE] : []),
  MenuItemId.PERSONAL_INFO,
  MenuItemId.SECURITY,
  MenuItemId.NOTIFY,
  MenuItemId.BOARD,
  MenuItemId.MESSAGE,
  MenuItemId.MAIL,
  MenuItemId.CALENDAR,
  MenuItemId.CONTACT,
  MenuItemId.DRIVE,
  MenuItemId.CLOVANOTE,
];

LNB.propTypes = {
  menuItemId: PropTypes.string.isRequired,
};
export default function LNB({ menuItemId }) {
  const { t } = useTranslation();
  const { menuDisplay, hasCampaignCodeBanner } = useContext(PageContext);

  const items = orderedItemIds.reduce((items, id) => {
    if (menuDisplay[id] === false) return items;

    const lowerName = id.toLowerCase();
    const url = MenuItemURL[id];
    return [...items, { id, lowerName, url }];
  }, []);

  const handleClickCampaignCodeLink = () => {
    window.open(
      Env.CAMPAIGNCODE_URL,
      'CAMPAIGNCODE',
      'width=770, height=900, scrollbars=yes',
    );
  };

  return (
    <div className="lnb">
      <div className="lnb_cover">
        <div className="menu_box">
          <ul className="menu_list">
            {items.map(({ id, lowerName, url }) => (
              <li
                key={id}
                className={classNames(lowerName, {
                  selected: id === menuItemId,
                })}
              >
                <A href={url} className="item">
                  <span className="item_txt">
                    {t(`menu_item_${lowerName}`, { context: Env.TARGET })}
                  </span>
                </A>
              </li>
            ))}
          </ul>
        </div>
        <div className="footer">
          {hasCampaignCodeBanner && (
            <div className="campaign_code">
              <p className="slogan">
                <Trans i18nKey="campaign_code_slogan" />
              </p>
              <a
                href="#"
                className="link"
                onClick={preventDefault(handleClickCampaignCodeLink)}
              >
                {t('campaign_code_link_label')}
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
